// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const AavoObjectTypeValues = [
	"PROJECT_ACTIVITY_MATERIAL",
	"CATALOG_PART",
	"CATALOG_PART_REVISION",
	"CHART_GROUP",
	"COMPANY",
	"CONFIGURATION_PRODUCT_FAMILY",
	"CONFIGURATION_COMPONENT",
	"CONTROL_CHART",
	"CONTROL_CHART_PARENT_GROUP",
	"C_CHART_EVENT",
	"CUSTOMER",
	"CUSTOMER_ORDER",
	"CUSTOMER_ORDER_LINE",
	"CUSTOMER_ORDER_OFFER",
	"CUSTOMER_ORDER_OFFER_LINE",
	"CUSTOMER_ORDER_CHANGE",
	"CUSTOMER_ORDER_BILLING_PLAN_LINE",
	"CUSTOMER_ORDER_PROFITABILITY_PLAN_LINE",
	"CUSTOMER_OFFER_BILLING_PLAN_LINE",
	"SPC_RECORD",
	"SPC_RESOURCE",
	"INVOICE",
	"OPERATION",
	"PART",
	"PART_CONFIGURATION",
	"PART_REVISION",
	"PART_REVISION_OPERATION",
	"PROCESS_IMPROVEMENT",
	"PRODUCT_CHANGE_REQUEST",
	"PRODUCT_CHANGE",
	"PROJECT",
	"PROJECT_ACTIVITY",
	"PROJECT_GROUP",
	"PURCHASE_ORDER",
	"PURCHASE_ORDER_LINE",
	"PURCHASE_ORDER_RECEIPT",
	"PURCHASE_CONTRACT",
	"RECLAMATION",
	"SAFETY_CONTROL_SURVEY",
	"SAFETY_CONTROL_SURVEY_NOTE",
	"SALES_LEAD",
	"SALES_PART",
	"SALES_CONTRACT",
	"SHOP_ORDER_BATCH",
	"SHOP_ORDER",
	"SHOP_ORDER_LINE",
	"SHOP_ORDER_OPERATION",
	"SALES_COMMISSION",
	"SALES_COMMISSION_LINE",
	"SITE",
	"SITE_TEXTS",
	"SUB_PROJECT",
	"SUPPLIER",
	"SUPPLIER_PART",
	"TASK",
	"WAREHOUSE_REPLENISHMENT",
	"WORKCENTER",
	"WORKSPACE",
	"DELIVERY",
	"DELIVERY_TRANSPORT",
] as const;

export type AavoObjectType = (typeof AavoObjectTypeValues)[number];

export const getAavoObjectTypeLabels = () => ({
	PROJECT_ACTIVITY_MATERIAL: t("project_activity_material"),
	CATALOG_PART: t("catalog_part"),
	CATALOG_PART_REVISION: t("catalog_part_revision"),
	CHART_GROUP: t("chart_group"),
	COMPANY: t("company"),
	CONFIGURATION_PRODUCT_FAMILY: t("configuration_product_family"),
	CONFIGURATION_COMPONENT: t("configuration_component"),
	CONTROL_CHART: t("control_chart"),
	CONTROL_CHART_PARENT_GROUP: t("control_chart_parent_group"),
	C_CHART_EVENT: t("c_chart_event"),
	CUSTOMER: t("customer"),
	CUSTOMER_ORDER: t("customer_order"),
	CUSTOMER_ORDER_LINE: t("customer_order_line"),
	CUSTOMER_ORDER_OFFER: t("customer_order_offer"),
	CUSTOMER_ORDER_OFFER_LINE: t("customer_order_offer_line"),
	CUSTOMER_ORDER_CHANGE: t("customer_order_change"),
	CUSTOMER_ORDER_BILLING_PLAN_LINE: t("customer_order_billing_plan_line"),
	CUSTOMER_ORDER_PROFITABILITY_PLAN_LINE: t("customer_order_profitability_plan_line"),
	CUSTOMER_OFFER_BILLING_PLAN_LINE: t("customer_offer_billing_plan_line"),
	SPC_RECORD: t("spc_record"),
	SPC_RESOURCE: t("spc_resource"),
	INVOICE: t("invoice"),
	OPERATION: t("operation"),
	PART: t("part"),
	PART_CONFIGURATION: t("part_configuration"),
	PART_REVISION: t("part_revision"),
	PART_REVISION_OPERATION: t("part_revision_operation"),
	PROCESS_IMPROVEMENT: t("process_improvement"),
	PRODUCT_CHANGE_REQUEST: t("product_change_request"),
	PRODUCT_CHANGE: t("product_change"),
	PROJECT: t("project"),
	PROJECT_ACTIVITY: t("project_activity"),
	PROJECT_GROUP: t("project_group"),
	PURCHASE_ORDER: t("purchase_order"),
	PURCHASE_ORDER_LINE: t("purchase_order_line"),
	PURCHASE_ORDER_RECEIPT: t("purchase_order_receipt"),
	PURCHASE_CONTRACT: t("purchase_contract"),
	RECLAMATION: t("reclamation"),
	SAFETY_CONTROL_SURVEY: t("safety_control_survey"),
	SAFETY_CONTROL_SURVEY_NOTE: t("safety_control_survey_note"),
	SALES_LEAD: t("sales_lead"),
	SALES_PART: t("sales_part"),
	SALES_CONTRACT: t("sales_contract"),
	SHOP_ORDER_BATCH: t("shop_order_batch"),
	SHOP_ORDER: t("shop_order"),
	SHOP_ORDER_LINE: t("shop_order_line"),
	SHOP_ORDER_OPERATION: t("shop_order_operation"),
	SALES_COMMISSION: t("sales_commission"),
	SALES_COMMISSION_LINE: t("sales_commission_line"),
	SITE: t("site"),
	SITE_TEXTS: t("site_texts"),
	SUB_PROJECT: t("sub_project"),
	SUPPLIER: t("supplier"),
	SUPPLIER_PART: t("supplier_part"),
	TASK: t("task"),
	WAREHOUSE_REPLENISHMENT: t("warehouse_replenishment"),
	WORKCENTER: t("workcenter"),
	WORKSPACE: t("workspace"),
	DELIVERY: t("delivery"),
	DELIVERY_TRANSPORT: t("delivery_transport"),
});

export const getAavoObjectTypeLabel = (value: AavoObjectType): string => {
	return getAavoObjectTypeLabels()[value];
};
